import styled from 'styled-components'
import blueGradientBlobs from '~/assets/blu-gradient-blobs-02.png'
import { backgroundBoxShadow } from '~/components/CommonStyles'
import { dimensions, spacing } from '~/constants/theme'

export const RootWrapper = styled.div`
  height: 100vh;
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-image: url(${blueGradientBlobs});
  background-size: cover;
  background-repeat: no-repeat;
`

export const ContentWrapper = styled.div`
  width: 33%;
  max-width: 400px;
  min-width: 320px;
  max-height: 650px;
  padding: ${spacing.spacingXL};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${dimensions.borderRadiusMD};
  box-sizing: border-box;
  background-color: var(--chakra-colors-bg-panel);
  ${backgroundBoxShadow};
`

export const LogoImage = styled.img`
  width: 100%;
  max-width: 200px;
  min-width: 200px;
  height: auto;
  margin: ${spacing.spacingXXXL} auto;
`

export const ErrorWrapper = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.spacingMD};
`

export const InputWrapper = styled.div`
  width: 90%;
  min-width: 200px;
  margin-bottom: ${spacing.spacingLG};
  border-radius: ${dimensions.borderRadiusSM};
  position: relative;
`

export const PassButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
`

export const LoginButtonWrapper = styled.div`
  margin: ${spacing.spacingXXXL} 0px;
  width: 100%;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LoginMessageWrapper = styled.div`
  width: 90%;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${spacing.spacingMD};
  margin-bottom: ${spacing.spacingXXXL};
`

export const LoginMessageActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.spacingMD};
`

export const ForgotButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing.spacingLG};
`

const focusRing = `
  &:focus-visible {
    outline: 2px solid var(--chakra-colors-brand-solid);
    outline-offset: 2px;
    border-radius: 2px;
  }
`

export const PasswordVisibilityButton = styled.button`
  margin-top: 1px;
  width: 24px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  ${focusRing}
`

export const ForgotButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  ${focusRing}
`

export const ForgotPasswordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  ${focusRing}
`

export const Wrapper = styled.div`
  width: 33vw;
  max-width: 642px;
  min-width: 400px;
  max-height: 650px;
  padding: 60px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${dimensions.borderRadiusMD};
  box-sizing: border-box;
  background-color: var(--chakra-colors-bg-panel);
  ${backgroundBoxShadow};
`

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${spacing.spacingLG};
`

export const PbxWrapper = styled.div`
  width: 100%;
  margin: ${spacing.spacingXL} 0px;
  box-sizing: border-box;
  border: 2px solid var(--chakra-colors-border-emphasized);
  border-radius: 12px;
  padding: 8px;
  background-color: var(--chakra-colors-bg-panel);
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${spacing.spacingLG};
  > div {
    margin: 0 6px;
  }
`

export const HelpWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 16px;
`

export const EmptyWrapper = styled(Wrapper)`
  padding: 60px 80px;
`
